import { render, staticRenderFns } from "./waitStudyDetail.vue?vue&type=template&id=37c75bc8&scoped=true&"
import script from "./waitStudyDetail.vue?vue&type=script&lang=js&"
export * from "./waitStudyDetail.vue?vue&type=script&lang=js&"
import style0 from "./waitStudyDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./waitStudyDetail.vue?vue&type=style&index=1&id=37c75bc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c75bc8",
  null
  
)

export default component.exports